import React, { useEffect } from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Button from "@material-ui/core/Button";
import { makeStyles } from "@material-ui/core/styles";
import { DateRange } from "@material-ui/icons";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  dateBox: {
    width: "299px",
    height: "60px",
    background: "#EBF4FF",
    borderRadius: "8px",
    margin: "3% 0 0 3%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-around",
    textAlign: "initial",
    alignContent: "flex-end",
    alignItems: "center",
  },
  installmentDateBox: {
    width: "299px",
    height: "60px",
    background: "#EBF4FF",
    borderRadius: "8px",
    margin: "3% 0 0 3%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-evenly",
    textAlign: "initial",
    alignContent: "flex-end",
    alignItems: "center",
  },
  showDate: { color: "#A3A3A3", fontSize: "10px", fontWeight: " 400" },
  buttonStyle: {
    backgroundColor: "#FFF",
    borderBlockColor: "#FF712D",
    color: "#FF712D",
  },
  headingStyle: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "10px",
    fontSize: "15px",
  },
  dateWeight: { fontWeight: "800", fontWeight: "bolder", fontSize: "initial" },
}));

const StudentBreakReponseModal = ({
  open,
  closeResponseModal,
  responseLeaveStart,
  responseLeaveEnd,
  newPaypalDate,
  paymentGateway,
  newDate,
  withPaymentDeferral,
}) => {
  const classes = useStyles();

  return (
    <>
      <Dialog open={open} maxWidth="md">
        <DialogContent style={{ textAlign: "center" }}>
          <div className="ml-3 mr-3">
            <h3 style={{ textAlign: "center" }}>Success!</h3>
            <div className={classes.headingStyle}>
              The student has been paused for the date range below.
            </div>
            <div className={classes.dateBox}>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div className={classes.showDate}>
                  <DateRange className={classes.showDate} />
                  FROM{" "}
                </div>
                <div className={classes.dateWeight}>
                  {moment(responseLeaveStart).format("DD-MM-YYYY")}
                </div>
              </div>
              <div style={{ display: "flex", flexDirection: "column" }}>
                <div className={classes.showDate}>
                  <DateRange className={classes.showDate} /> TO
                </div>
                <div className={classes.dateWeight}>
                  {moment(responseLeaveEnd).format("DD-MM-YYYY")}
                </div>
              </div>
            </div>
            {withPaymentDeferral && (
              <div className={classes.installmentDateBox}>
                <div>Next Installment Date: </div>
                <div className={classes.dateWeight}>
                  {" "}
                  {paymentGateway === "paypal"
                    ? new Date(newPaypalDate).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })
                    : newDate
                    ? new Date(newDate).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "2-digit",
                        year: "numeric",
                      })
                    : "Not Available"}
                </div>
              </div>
            )}
          </div>
        </DialogContent>
        <DialogActions
          style={{
            display: "flex",
            justifyContent: "center",
            marginBottom: "20px",
          }}
        >
          <Button
            className={classes.buttonStyle}
            variant="contained"
            onClick={() => {
              closeResponseModal({ isError: false });
            }}
          >
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default StudentBreakReponseModal;
